(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  const initializeProductHelpFields = (scope = document) => {
    scope.querySelectorAll('[data-section-type="contact-form"]').forEach((section) => {
      const wrappers = Array.from(section.querySelectorAll('.contact-form__input-wrapper'));

      section.querySelectorAll('[data-product-help-field]').forEach((field) => {
        if (field.dataset.productHelpInitialized === 'true') return;

        const fieldIndex = wrappers.indexOf(field);
        let reasonSelect;

        for (let index = fieldIndex - 1; index >= 0; index -= 1) {
          reasonSelect = wrappers[index].querySelector('select');
          if (reasonSelect) break;
        }

        if (!reasonSelect) return;

        field.dataset.productHelpInitialized = 'true';

        const input = field.querySelector('[data-product-help-input]');
        const suggestions = field.querySelector('[data-product-help-suggestions]');
        const cache = new Map();
        let debounceTimer;
        let requestController;
        let activeIndex = -1;

        const clearSuggestions = () => {
          suggestions.replaceChildren();
          suggestions.hidden = true;
          input.setAttribute('aria-expanded', 'false');
          input.removeAttribute('aria-activedescendant');
          activeIndex = -1;
        };

        const setActiveSuggestion = (index) => {
          const options = Array.from(suggestions.querySelectorAll('[role="option"]'));
          if (options.length === 0) return;

          activeIndex = Math.max(0, Math.min(index, options.length - 1));

          options.forEach((option, optionIndex) => {
            const isActive = optionIndex === activeIndex;
            option.classList.toggle('is-active', isActive);
            option.setAttribute('aria-selected', isActive.toString());
          });

          const activeOption = options[activeIndex];
          input.setAttribute('aria-activedescendant', activeOption.id);
          activeOption.scrollIntoView({ block: 'nearest' });
        };

        const selectSuggestion = (option) => {
          input.value = option.dataset.value;
          clearSuggestions();
          input.focus();
        };

        const updateVisibility = () => {
          const isProductInquiry = reasonSelect.selectedIndex === 0;
          field.hidden = !isProductInquiry;
          input.disabled = !isProductInquiry;

          if (!isProductInquiry) {
            input.value = '';
            clearSuggestions();
          }
        };

        const renderSuggestions = (products) => {
          const fragment = document.createDocumentFragment();
          const titles = new Set();

          products.forEach((product, index) => {
            const title = product.title?.replace(/\s*\(CZ\/SK\)\s*$/i, '').trim();
            if (!title || titles.has(title)) return;
            titles.add(title);

            const option = document.createElement('button');
            option.type = 'button';
            option.id = `${input.id}-suggestion-${index}`;
            option.className = 'contact-form__product-suggestion';
            option.dataset.value = title;
            option.setAttribute('role', 'option');
            option.setAttribute('aria-selected', 'false');
            option.tabIndex = -1;
            option.textContent = title;
            fragment.appendChild(option);
          });

          suggestions.replaceChildren(fragment);
          suggestions.hidden = suggestions.children.length === 0;
          input.setAttribute('aria-expanded', (!suggestions.hidden).toString());
          activeIndex = -1;
        };

        const loadSuggestions = async () => {
          const query = input.value.trim();

          if (query.length < 2) {
            clearSuggestions();
            return;
          }

          if (cache.has(query)) {
            renderSuggestions(cache.get(query));
            return;
          }

          requestController?.abort();
          requestController = new AbortController();

          const params = new URLSearchParams({
            q: query,
            'resources[type]': 'product',
            'resources[limit]': '6',
            'resources[options][unavailable_products]': 'hide',
          });

          try {
            const response = await fetch(`${section.dataset.predictiveSearchUrl}.json?${params.toString()}`, {
              headers: { Accept: 'application/json' },
              signal: requestController.signal,
            });

            if (!response.ok) return;

            const data = await response.json();
            const products = data.resources?.results?.products || [];
            cache.set(query, products);
            renderSuggestions(products);
          } catch (error) {
            if (error.name !== 'AbortError') clearSuggestions();
          }
        };

        reasonSelect.addEventListener('change', updateVisibility);
        input.addEventListener('input', () => {
          clearTimeout(debounceTimer);
          clearSuggestions();
          debounceTimer = setTimeout(loadSuggestions, 250);
        });
        input.addEventListener('keydown', (event) => {
          const options = suggestions.querySelectorAll('[role="option"]');

          if (event.key === 'ArrowDown' && options.length > 0) {
            event.preventDefault();
            setActiveSuggestion(activeIndex + 1);
          } else if (event.key === 'ArrowUp' && options.length > 0) {
            event.preventDefault();
            setActiveSuggestion(activeIndex <= 0 ? options.length - 1 : activeIndex - 1);
          } else if (event.key === 'Enter' && activeIndex >= 0) {
            event.preventDefault();
            selectSuggestion(options[activeIndex]);
          } else if (event.key === 'Escape') {
            clearSuggestions();
          }
        });
        suggestions.addEventListener('mousedown', (event) => {
          const option = event.target.closest('[role="option"]');
          if (!option) return;

          event.preventDefault();
          selectSuggestion(option);
        });
        document.addEventListener('pointerdown', (event) => {
          if (!field.contains(event.target)) clearSuggestions();
        });

        updateVisibility();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeProductHelpFields());
  } else {
    initializeProductHelpFields();
  }

  document.addEventListener('shopify:section:load', (event) => initializeProductHelpFields(event.target));

  } catch(e) { console.error(e); }
})();
})();
